import React from "react";
import { createPortal } from "react-dom";
export default function CreateTeamDrawer({
  open,
  onClose,
  onSubmit,
  departments,
  employees,
}) {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/40 flex justify-end z-50">
      <div className="bg-white w-[400px] h-full shadow-2xl overflow-y-auto">
        
        {/* Header */}
        <div className="flex justify-between items-center p-5 border-b">
          <h2 className="text-lg font-semibold">Create Team</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black text-xl"
          >
            ✕
          </button>
        </div>

        {/* Form */}
        <form onSubmit={onSubmit} className="p-5">
          
          {/* Team Name */}
          <input
            name="name"
            placeholder="Team Name"
            className="w-full border rounded-md p-2 mb-4"
            required
          />

          {/* Department */}
          <select
            name="department_id"
            className="w-full border rounded-md p-2 mb-4"
            required
          >
            <option value="">Select Department</option>
            {departments.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>

          {/* Members */}
          <div className="border rounded-md p-3 max-h-40 overflow-y-auto mb-4">
            {employees.map((emp) => (
              <label key={emp.id} className="block text-sm mb-1">
                <input
                  type="checkbox"
                  name="members"
                  value={emp.id}
                  className="mr-2"
                />
                {emp.first_name} {emp.last_name}
              </label>
            ))}
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-400 text-white rounded-md"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="px-4 py-2 bg-purple-600 text-white rounded-md"
            >
              Create
            </button>
          </div>
        </form>
      </div>
  
    </div>,
        document.body
  );
}